module.exports = __webpack_public_path__ + "img/logo_tavo.7d4fc7d7.png";